import { z } from 'zod';
import { FINDING_TYPES, FINDING_TYPE_SOURCES } from '@terra/shared-cvss';

export const FindingTypeFieldsSchema = z.object({
  findingType: z.enum(FINDING_TYPES).nullable().optional(),
  findingTypeReason: z.string().nullable().optional(),
  findingTypeSource: z.enum(FINDING_TYPE_SOURCES).nullable().optional(),
});
